import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { LoginService } from '../services/login.service';
import { RestClientService } from '../services/restclient.service';
import { Identificador } from '../modelo/identificador';
import { MensagemService } from '../services/mensagem.service';
import { Autenticado } from '../modelo/autenticado';
import { ConfiguracaoVisualService } from '../services/configuracaoVisual.service';
import { TreatDate } from '../util/treatDate';
import { MatDialog } from '@angular/material';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';
import { MidiaEnum } from '../enumaration/midiaEnum';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ConfiguracaoVisual } from '../modelo/configuracaoVisual';
import { BraRecaptchaComponent } from '../componentes/bra-recaptcha/bra-recaptcha.component';
import { Recaptcha } from '../modelo/captcha';
import { CriptoService } from '../services/cripto.service';
import { RedefinirSenhaModalInvalidoComponent } from './redefinir-senha-modal-invalido';

declare var $: any;

@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./login.component.css'],
  providers: [
    LoginService,
    ConfiguracaoVisualService,
    RestClientService,
    MensagemService,
    CriptoService,
  ],
})
export class RedefinirSenhaComponent
  extends AbstractComponent
  implements OnInit
{
  titulo: string = '';
  cdPagina: number | null = null;
  identificador: Identificador = new Identificador();
  msgSenha: string = '';
  mensagemCpfCnpj: string = '';
  keyRecaptcha: string = '';
  checkTamanho: boolean = false;
  checkMaiusMinus: boolean = false;
  checkNumero: boolean = false;
  checkEspecial: boolean = false;
  checkSequencia: boolean = false;
  disabledConfirmeSenha: boolean = false;
  tipSenhaAtivo: boolean = false;
  isLoaded = false;
  private aguardandoTokenRecaptcha = false;

  @ViewChild(BraRecaptchaComponent) recaptchaElem: BraRecaptchaComponent | undefined;

  /**
   * Construtor padrão
   */
  constructor(
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private mensagemService: MensagemService,
    private sessaoService: SessaoService,
    private loginService: LoginService,
    private spinnerService: Ng4LoadingSpinnerService,
    private configuracaoVisualService: ConfiguracaoVisualService,
    public dialog: MatDialog,
    private criptoService: CriptoService,
  ) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    var url = this.route.snapshot.routeConfig ? this.route.snapshot.routeConfig.path : '';
    var id_parceiro = 1;
    if (url == 'redefinirSenha-ford') {
      id_parceiro = 2;
    } else if (url == 'redefinirSenha-jeep') {
      id_parceiro = 3;
    }
    this.selecionarParceiro(id_parceiro, false);
    this.forcarLimpezaSessao();

    // Inicializa variáveis
    this.identificador = new Identificador();
    this.identificador.cdChaveForte = '2';
    this.identificador.cdChaveFraca =
      '' + ((window.crypto.getRandomValues(new Uint8Array(1))[0] % 4) + 1);

    this.identificador.cdMidia = MidiaEnum.INTERNET;

    // Captura parametros
    this.cdPagina = Number(this.activatedRoute.snapshot.params['cdPagina']);

    if (this.cdPagina === 1) {
      this.titulo = this.getMensagem('PRIMEIRO_ACESSO');
      sessionStorage.setItem('modalPrimeiroAcesso', 'true');
    } else {
      this.titulo = this.getMensagem('REDEFINIR_SENHA');
    }

    var WindowsSize = function () {
      // Toggle menu abrir conforme a resolucao
      var h = $('.loginBox').height(),
        w = $(window).width();

      // Conteudo altura
      $('.login').css('height', h + 200);
      $('.footer').css('width', w);
    };
    $(document).ready(WindowsSize);
    $(window).resize(WindowsSize);
  }

  /**
   * Força a limpeza da sessão
   */
  forcarLimpezaSessao() {
    sessionStorage.removeItem('sessao');
    sessionStorage.clear();
    this.sessaoService.sessao.logado = false;
  }

  /**
   * Acionado pelo recaptcha após a validação ou expiração
   * @param token
   */
  onTokenChanged(token: string) {
    this.identificador.token = token;

    if (!this.aguardandoTokenRecaptcha || !token) {
      return;
    }

    this.aguardandoTokenRecaptcha = false;
    if (this.validacaoBasica()) {
      this.criptografarSenha();
    }
  }

  /**
   * Avança para a inclusão ou atualização do cadastro
   */
  onClickAvancar = (): void => {
    if (this.precisaExecutarRecaptchaInvisivel() && this.recaptchaElem) {
      this.identificador.token = '';
      this.aguardandoTokenRecaptcha = true;
      this.recaptchaElem.execute();
      return;
    }

    if (!this.validacaoBasica()) {
      this.identificador.token = '';
      this.aguardandoTokenRecaptcha = false;
      this.identificador.vrSenha = '';
      this.identificador.vrConfirmacaoSenha = '';
      this.checkTamanho = false;
      this.checkMaiusMinus = false;
      this.checkNumero = false;
      this.checkEspecial = false;
      this.checkSequencia = false;
      this.mensagemService.show(this.campos);
      if (this.recaptchaElem) this.recaptchaElem.reload();
      return;
    } else {
      this.criptografarSenha();
    }
  };

  private precisaExecutarRecaptchaInvisivel(): boolean {
    return !!this.keyRecaptcha && !!this.recaptchaElem;
  }

  /**
   * Realiza a criptografia da senha
   */
  criptografarSenha() {
    this.criptoService.criptografar(this.identificador.vrSenha).then((data) => {
      this.identificador.vrSenha = data;
      this.identificador.vrConfirmacaoSenha = data;
      this.validarPrimeiroAcesso();
    });
  }

  /**
   * Clique do botão voltar
   */
  onClickVoltar = (): void => {
    window.history.back();
  };

  /**
   * Redireciona para a tela de token
   */
  redefinirSenhaToken = () => {
    this.router.navigate(['/redefinirSenhaToken', { cdPagina: 3 }]);
  };

  /**
   * Validação das regras de senha
   */
  validarRegrasSenha(senha: string) {
    const checkLeastLowerUpper = /(?=.*[a-z])(?=.*[A-Z])/g;
    const checkLeastNumber = /(?=.*\d)/g;
    this.checkTamanho = senha.length >= 8 && senha.length <= 10;
    this.checkMaiusMinus = checkLeastLowerUpper.test(senha);
    this.checkNumero = checkLeastNumber.test(senha);

    this.checkEspecial = this.validarCaracteresNaoAutorizados(senha);
    this.checkSequencia = this.validarCaracteresSequenciais(senha);
  }

  /**
   * Valida se a senha possui sequencias de 3 digitos de numeros ou letras
   */
  validarCaracteresSequenciais(senha: string): boolean {
    // Retorna false se na String existe 3 numeros em sequencia -> ex: 123
    for (let i = 0; i < senha.length; i++) {
      if (
        senha.charAt(i + 1) === (Number(senha.charAt(i)) + 1).toString() &&
        senha.charAt(i + 2) === (Number(senha.charAt(i)) + 2).toString()
      ) {
        return false;
      }
    }

    // Retorna false se na String existe 3 caracteres em sequencia alfabetica -> ex: abc
    for (let i = 0; i < senha.length; i++) {
      if (
        String.fromCharCode(senha.charCodeAt(i) + 1) === senha.charAt(i + 1) &&
        String.fromCharCode(senha.charCodeAt(i) + 2) === senha.charAt(i + 2)
      ) {
        return false;
      }
    }

    return true;
  }

  validarCaracteresNaoAutorizados(senha: string): boolean {
    const checkLeastPadraoNaoPermitido = /(?=.*[^a-zA-Z0-9!@$&*#])/g;
    const checkLeastSpecialPermitido = /(?=.*[!@$&*#])/g;

    if (
      checkLeastSpecialPermitido.test(senha) &&
      !checkLeastPadraoNaoPermitido.test(senha)
    ) {
      return true;
    }
    return false;
  }

  /**
   * Validação Básica da tela
   */
  validacaoBasica = (): boolean => {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;

    if (!this.identificador.cdTipoCpfCnpj) {
      this.campos.push('tipoDoc');
      isValid = false;
    }

    if (!this.identificador.nuCpfCnpj) {
      this.mensagemCpfCnpj = this.getMensagem('CPF_CNPJ_OBRIGATORIO');
      this.campos.push('cpfCnpj');
      isValid = false;
    }

    if (!this.identificador.nuChassi) {
      this.campos.push('numeroChassi');
      isValid = false;
    }

    if (
      this.identificador.cdChaveFraca === '1' &&
      !this.identificador.dtDiaVencimento
    ) {
      this.campos.push('diaVencimentoParcela');
      isValid = false;
    }

    if (
      this.identificador.cdChaveFraca === '2' &&
      (!this.identificador.dtNascimento ||
        !TreatDate.validaData(this.identificador.dtNascimento))
    ) {
      this.campos.push('dataNascimento');
      isValid = false;
    }

    if (
      this.identificador.cdChaveFraca === '3' &&
      !this.identificador.qtParcela
    ) {
      this.campos.push('quantidadeParcela');
      isValid = false;
    }

    if (
      this.identificador.cdChaveFraca === '4' &&
      !this.identificador.dtAnoFabricacao
    ) {
      this.campos.push('anoFabricacao');
      isValid = false;
    }

    if (
      this.identificador.cdChaveFraca === '4' &&
      !this.identificador.dtAnoModelo
    ) {
      this.campos.push('anoModelo');
      isValid = false;
    }

    if (this.keyRecaptcha && !this.identificador.token) {
      this.campos.push('codigoImagem');
      isValid = false;
    }

    if (!this.identificador.vrSenha) {
      this.msgSenha = this.getMensagem('SENHA_OBRIGATORIA');
      this.campos.push('senha');
      isValid = false;
    }

    if (!this.identificador.vrConfirmacaoSenha) {
      this.msgSenha = this.getMensagem('SENHA_OBRIGATORIA');
      this.campos.push('confirmaSenha');
      isValid = false;
    }

    if (
      this.identificador.vrSenha &&
      this.identificador.vrConfirmacaoSenha &&
      this.identificador.vrSenha !== this.identificador.vrConfirmacaoSenha
    ) {
      this.msgSenha = this.getMensagem('SENHA_CONFERE_CONFIRMACAO');
      this.campos.push('senha');
      this.campos.push('confirmaSenha');
      isValid = false;
    }

    return isValid;
  };

  /**
   * Verifica a situação do cadastro do usuário
   */
  validarPrimeiroAcesso() {
    if (this.identificador.cdTipoCpfCnpj === '1') {
      this.identificador.nuCpfCnpj = this.identificador.nuCpfCnpj.replace(/[^\d]+/g, '');
    } else {
      this.identificador.nuCpfCnpj = this.identificador.nuCpfCnpj.replace(/[^A-Za-z0-9]/g, '');
    }
    this.loginService.validarPrimeiroAcesso(this.identificador).subscribe(
      (result: Autenticado) => {
        this.spinnerService.hide();
        if (result.cdMsgemRetorno === '0') {
          this.sessaoService.sessao.logado = true;
          this.sessaoService.sessao.autenticado = result;
          sessionStorage.setItem(
            'sessaoBF',
            JSON.stringify(this.sessaoService.sessao),
          );
          sessionStorage.setItem('TEMPO_SESSAO', result.tempoSessao ? result.tempoSessao : '');
          this.selecionarParceiro(result.parceiro.cdParceiro, true);
        } else if (
          result.cdMsgemRetorno === '21' ||
          result.cdMsgemRetorno === '5001' ||
          result.cdMsgemRetorno === '5005'
        ) {
          this.dialog.open(RedefinirSenhaModalInvalidoComponent, {
            width: Config.POPUP_50VW,
          });
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno,
              codigo: result.cdMsgemRetorno,
              linkChat:
                result.cdMsgemRetorno === '8' || result.cdMsgemRetorno === '22',
            },
          });
          this.identificador.vrSenha = '';
          this.identificador.vrConfirmacaoSenha = '';
          this.identificador.token = '';
          this.aguardandoTokenRecaptcha = false;
          this.checkTamanho = false;
          this.checkMaiusMinus = false;
          this.checkNumero = false;
          this.checkEspecial = false;
          this.checkSequencia = false;
          if (this.recaptchaElem) this.recaptchaElem.reload();
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(
          this.getMensagem('ERRO_CHAMADA_SERVICO'),
        );
      },
      () => {
        this.spinnerService.hide();
      },
    );
  }

  /**
   * Método para seleção do parceiro
   */
  selecionarParceiro = (cdParceiro: number, redirect: boolean): void => {
    this.configuracaoVisualService
      .recuperarConfiguracaoParceiro(cdParceiro)
      .subscribe(
        (result: ConfiguracaoVisual) => {
          this.spinnerService.hide();
          if (result.cdMsgemRetorno === '0' || result.cdMsgemRetorno === '2') {
            this.sessaoService.sessao.configuracaoVisual = result;
            this.sessaoService.sessao.cor =
              'rgb(' +
              result.nuCorR +
              ', ' +
              result.nuCorG +
              ', ' +
              result.nuCorB +
              ')';
            sessionStorage.setItem(
              'sessaoBF',
              JSON.stringify(this.sessaoService.sessao),
            );
            if (redirect) this.router.navigate(['primeiro-acesso-token']);
            else this.obterTipoValidacao();
          } else {
            this.dialog.open(BraAlertComponent, {
              width: Config.POPUP_50VW,
              data: {
                mensagem: result.dsMsgemRetorno,
              },
            });
          }
        },
        () => {
          this.mensagemService.servicoIndisponivel(
            this.getMensagem('ERRO_CHAMADA_SERVICO'),
          );
        },
        () => {
          this.spinnerService.hide();
        },
      );
  };

  /**
   * Obtém o tipo de validação
   */
  obterTipoValidacao() {
    this.keyRecaptcha = this.sessaoService.sessao.keyRecaptcha;
    if (this.keyRecaptcha) {
      this.isLoaded = true;
    } else {
      this.obterRecaptcha();
    }
  }

  /**
   * Obtem o recaptcha para renderização
   */
  obterRecaptcha() {
    this.loginService.obterReCaptcha().subscribe(
      (result: Recaptcha) => {
        this.spinnerService.hide();
        if (result && result.nmRecaptcha) {
          this.isLoaded = true;
          this.sessaoService.sessao.keyRecaptcha = result.nmRecaptcha;
          this.keyRecaptcha = result.nmRecaptcha;
        } else {
          this.mensagemService.servicoIndisponivel(
            this.getMensagem('ERRO_CHAMADA_SERVICO'),
          );
        }
      },
      () => {
        this.mensagemService.servicoIndisponivel(
          this.getMensagem('ERRO_CHAMADA_SERVICO'),
        );
      },
      () => {
        this.spinnerService.hide();
      },
    );
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/login/redefinir-senha.component.ts